module.exports = __webpack_public_path__ + "static/img/1027.6e3bace.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1027.jpg
// module id = 209
// module chunks = 0